import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { COLORS, TYPOGRAPHY, SPACING, SHADOWS, RADIUS, TRANSITIONS, GRADIENTS, HERO_HEIGHTS, ANIMATIONS } from '../constants/designTokens';
import { SITE } from '../constants/siteConfig';

const HeroSection = () => (
    <section className="hero-section d-flex align-items-center" style={{
        minHeight: HERO_HEIGHTS.default,
        background: `${GRADIENTS.overlay}, url('/img/vessel-hero.jpg') center center / cover no-repeat`,
        color: COLORS.text.white,
        position: "relative",
        overflow: "hidden",
        padding: "80px 0"
    }}>
                <style>{`
                    @keyframes gradientShift {
                        ${ANIMATIONS.gradientShift}
                    }

                    .hero-section h1 {
                        font-size: ${TYPOGRAPHY.fontSize['4xl']};
                        font-weight: ${TYPOGRAPHY.fontWeight.bold};
                        color: ${COLORS.text.white};
                        text-shadow: ${SHADOWS.md};
                        position: relative;
                        z-index: 2;
                        line-height: ${TYPOGRAPHY.lineHeight.tight};
                    }
                    .hero-section p {
                        font-size: ${TYPOGRAPHY.fontSize.xl};
                        color: ${COLORS.text.white};
                        opacity: 0.95;
                        margin-bottom: ${SPACING['2xl']};
                        position: relative;
                        z-index: 2;
                        line-height: ${TYPOGRAPHY.lineHeight.relaxed};
                    }
                    .hero-media {
                        border-radius: ${RADIUS.xl};
                        box-shadow: ${SHADOWS.xl};
                        max-width: 100%;
                        height: auto;
                        position: relative;
                        z-index: 2;
                    }
                    .hero-section .container {
                        position: relative;
                        z-index: 2;
                    }

                    .container-buttons {
                        display: flex;
                        gap: ${SPACING.md};
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }

                    .btn-sealink-services {
                        background: ${COLORS.primary.teal};
                        border: none;
                        padding: ${SPACING.md} ${SPACING.xl};
                        border-radius: ${RADIUS.lg};
                        font-weight: ${TYPOGRAPHY.fontWeight.semibold};
                        transition: ${TRANSITIONS.all};
                        box-shadow: ${SHADOWS.md};
                    }
                    .btn-sealink-services:hover,
                    .btn-sealink-services:focus {
                        background: ${COLORS.primary.dark} !important;
                        transform: translateY(-2px);
                        box-shadow: ${SHADOWS.hover.md};
                    }
                    .btn-sealink-whatsapp {
                        background: ${COLORS.ui.whatsapp};
                        border: none;
                        padding: ${SPACING.md} ${SPACING.xl};
                        border-radius: ${RADIUS.lg};
                        font-weight: ${TYPOGRAPHY.fontWeight.semibold};
                        transition: ${TRANSITIONS.all};
                        box-shadow: ${SHADOWS.md};
                    }
                    .btn-sealink-whatsapp:hover,
                    .btn-sealink-whatsapp:focus {
                        background: ${COLORS.ui.whatsappHover} !important;
                        transform: translateY(-2px);
                        box-shadow: ${SHADOWS.hover.md};
                    }
                    @media (max-width: 767.98px) {
                        .hero-section h1 {
                            font-size: ${TYPOGRAPHY.fontSize['2xl']};
                        }
                        .hero-section {
                            padding: ${SPACING['2xl']} 0;
                        }
                        .hero-section p {
                            font-size: ${TYPOGRAPHY.fontSize.md};
                        }
                        .container-buttons {
                            justify-content: center;
                        }
                        /* Hide video on mobile to save data and improve performance */
                        .hero-bg-video {
                            display: none;
                        }
                        .hero-stats {
                            display: none !important;
                        }
                    }

                    .hero-stats {
                        margin-top: 32px;
                    }
                    .hero-stats .stat-item {
                        transition: transform 0.3s ease;
                    }
                    .hero-stats .stat-item:hover {
                        transform: translateY(-4px);
                    }
                    @media (prefers-reduced-motion: reduce) {
                        .hero-stats .stat-item:hover {
                            transform: none;
                        }
                    }
                    .whatsapp-icon {
                        margin-right: ${SPACING.xs};
                    }
                `}</style>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
                            <h1>Marine Sealink B.V.</h1>
                            <p>{SITE.tagline}. Your specialist supplier of quality marine spare parts: electrical, instrumentation &amp; control, OWS &amp; ODME, and fire &amp; smoke detection, sourced fast and delivered to vessels worldwide.</p>
                            <div className="container-buttons">
                                <a href="#contact" className="btn btn-primary btn-lg btn-sealink-services">Request a Quote</a>
                                <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg btn-sealink-whatsapp">
                                    <i className="fab fa-whatsapp whatsapp-icon"></i> WhatsApp
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center">
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                borderRadius: '16px',
                                padding: '32px',
                                marginTop: '32px',
                            }}>
                                <div className="row g-4" style={{ '--bs-gutter-x': '24px' }}>
                                    <div className="col-4 mb-2">
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}>
                                            <div style={{
                                                fontSize: '2rem',
                                                fontWeight: 'bold',
                                                color: COLORS.text.white,
                                                marginBottom: '8px',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                            }}>4</div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: COLORS.text.white,
                                                opacity: '0.9',
                                            }}>Core Categories</div>
                                        </div>
                                    </div>
                                    <div className="col-4 mb-2">
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}>
                                            <div style={{
                                                fontSize: '2rem',
                                                fontWeight: 'bold',
                                                color: COLORS.text.white,
                                                marginBottom: '8px',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                            }}>24-72h</div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: COLORS.text.white,
                                                opacity: '0.9',
                                            }}>Delivery</div>
                                        </div>
                                    </div>
                                    <div className="col-4 mb-2">
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}>
                                            <div style={{
                                                fontSize: '2rem',
                                                fontWeight: 'bold',
                                                color: COLORS.text.white,
                                                marginBottom: '8px',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                            }}>100%</div>
                                            <div style={{
                                                fontSize: '13px',
                                                color: COLORS.text.white,
                                                opacity: '0.9',
                                            }}>Quality Assured</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
);

export default HeroSection;
